/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('bootstrap-input-spinner');
window.number_format = require('./number_format');

//let places = require('places.js');

// Custom icons
require('../icons/icon-veggie.svg');
require('../icons/icon-lactose.svg');
require('../icons/icon-gluten.svg');

//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//   el: '#app',
// });

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

let searchSettings = {
  address: '',
  streetnr: '',
  address_suffix: '',
  postal: '',
  city: '',
};
let shippingXhr = null;
let shippingCost = 0;

function getTotalForProducts()
{
  let total = 0;
  let $products = $('.cart-products .product');
  $products.each(function () {
    let $e = $(this);
    let price = parseFloat($e.data('price'));
    let amount = parseInt($e.find('input.amount').val());
    total += price * amount;
  });
  return total;
}

function recalcTotals()
{
  let total = getTotalForProducts();
  let $products = $('.cart-products .product');
  if ($products.length == 0) {
    $('.no-products').show();
  } else {
    $('.no-products').hide();
  }

  if (window.delivery_method) {
    if (total < window.delivery_method.needed_amount) {
      $('.need-more').find('.amount').html('€ ' + number_format(window.delivery_method.needed_amount, 2, ',', ' '));
      $('.need-more').show();
      $('.submit-btn').prop('disabled', true);
    } else {
      $('.need-more').hide();
      $('.submit-btn').prop('disabled', false);
    }

    $('[class^="show-if-delivery-method-"], [class*=" show-if-delivery-method-"]').hide();
    $('.show-if-delivery-method-' + window.delivery_method.type).show();
  }

  // if (total < window.delivery_method.free_amount) {
  //   $('.need-more').find('.amount').html('€ ' + number_format(window.delivery_method.needed_amount, 2, ',', ' '));
  //   $('.need-more').show();
  // } else {
  //   $('.need-more').hide();
  // }

  $('.product-total-price').html('€ ' + number_format(total, 2, ',', ' '));
  $('.cart-total-price').html('€ ' + number_format(total, 2, ',', ' '));

  $('.total-cost-overview .cost-products .value').html('€ ' + number_format(total, 2, ',', ' '));
  $('.total-cost-overview .cost-delivery .value').html('€ ' + number_format(shippingCost, 2, ',', ' '));
  if (shippingCost > 0) {
    $('.total-cost-overview .cost-delivery').show();
  } else {
    $('.total-cost-overview .cost-delivery').hide();
  }
  $('.total-cost-overview .cost-total .value').html('€ ' + number_format(parseFloat(total) + parseFloat(shippingCost), 2, ',', ' '));
}

$(function () {
  $('[data-toggle="tooltip"]').tooltip();

  function setDeliveryMethod(key) {
    if (!key) {
      return;
    }
    $('.delivery-info').hide();
    $('.delivery-info[data-delivery-key="' + key + '"]').show();
    window.delivery_method = window.json_delivery_methods[key];
    recalcTotals();
    calculateShippingCost();

    $('.payment-method-c').hide();
    $('.payment-method-c[data-type="' + window.delivery_method.type + '"]').show();
    $('.payment-method-c[data-type="online"]').show();

    let selectedPaymentMethod = $('input[name="payment_method"]:checked').val();
    let $paymentMethod = $('input[name="payment_method"][value="' + selectedPaymentMethod + '"]');
    if (!$paymentMethod.is(':visible')) {
      //$('input[name="payment_method"]:visible').first().trigger('click');
      //handlePaymentMethodChange($('input[name="payment_method"]:visible').first());
      $('input[name="payment_method"]').prop('checked', false);
      handlePaymentMethodChange(null);
    }
  }

  $('input[name="payment_method"]').prop('checked', false);
  handlePaymentMethodChange(null);
  //$('input[name="payment_method"]').first().trigger('click');
  //handlePaymentMethodChange($('input[name="payment_method"]').first());
  $('input[name="delivery_method"]').on('change', function () {
    let key = $(this).val();
    setDeliveryMethod(key);
  });
  setDeliveryMethod($('input[name="delivery_method"]').first().val());
  $('input[name="delivery_method"]').first().prop('checked', true);
  //$('input[name="delivery_method"]').first().trigger('click');
  recalcTotals();
  calculateShippingCost();

  function addProductToCart(productData, extraInfo = '', supplementCost = 0, optionsDetails = []) {
    let productId = productData.id;
    productData['price'] = parseFloat(productData['price']);
    supplementCost = parseFloat(supplementCost);

    // Do +1 if already in cart
    let done = false;
    $('.cart-products .product').each(function () {
      let $cartProduct = $(this);
      if ($cartProduct.data('id') == productId && $cartProduct.data('extraInfo') == extraInfo) {
        let $amount = $cartProduct.find('input.amount');
        $amount.val(parseInt($amount.val()) + 1);
        $amount.trigger('change');
        done = true;
        return false;
      }
    });
    if (done) {
      return;
    }

    let $tpl = $('.cart-product-tpl');
    let $item = $tpl.clone();
    $item.removeClass('cart-product-tpl');

    let $injects = $item.find('[html-inject]');
    $injects.each(function () {
      let $e = $(this);
      let key = $e.attr('html-inject');

      if (key == 'price-formatted') {
        $(this).html(number_format(productData['price'] + supplementCost, 2, ',', ' '));
      } else if (key in productData) {
        $(this).html(productData[key]);
      }
    });

    $injects = $item.find('[src-inject]');
    $injects.each(function () {
      let $e = $(this);
      let key = $e.attr('src-inject');
      if (key in productData) {
        $(this).attr('src', productData[key]);
      }
    });
    $item.data('price', productData['price'] + supplementCost);
    $item.data('id', productData['id']);
    $item.data('supplementCost', supplementCost);
    $item.data('extraInfo', extraInfo);
    $item.data('optionsDetails', optionsDetails);
    $item.find('input[type="number"]').inputSpinner();
    $item.find('.description .hide').remove();
    if (extraInfo) {
      $item.find('.description').append('<span class="extraInfo alert-warning" style="display: block; margin-top: 10px; padding: 10px;">' + extraInfo + '</span>');
    }
    $('.cart-products').append($item);

    // Take minimum quantity into account
    if (productData['metadata'] && productData['metadata']['qty_min']) {
      $qtyField = $item.find('input[type="number"]');
      $qtyField.val(parseInt(productData['metadata']['qty_min']));
      $qtyField.attr('min', parseInt(productData['metadata']['qty_min']));
    }

    // Update totals
    recalcTotals();
    calculateShippingCost();

    // Show toast message
    $('.add-to-cart-toast').toast('show');
  }

  $('#optionsModal .btn-confirm').on('click', function () {
    let $selectedOptions = $('#optionsModal .option-group .select-items');
    let extraInfo = [];
    let optionsDetails = []
    let supplementCost = 0;
    $selectedOptions.each(function () {
      let $option = $(this);
      let $optionElement = $option.find('option:selected');
      if ($optionElement.length && $optionElement.data('price') > 0) {
        supplementCost += $optionElement.data('price');
      }
      extraInfo.push($option.val());
      optionsDetails.push({
        'title': $optionElement.data('title'),
        'price': $optionElement.data('price'),
      });
    });
    extraInfo = extraInfo.join('<br>');

    if (window.currentProduct && extraInfo) {
      addProductToCart(window.currentProduct, extraInfo, supplementCost, optionsDetails);
      $('#optionsModal').modal('hide');
    }
  });

  $('#optionsModal').on('change', '.select-items', function () {
    let $items = $('#optionsModal .option-group .select-items');
    let disabled = false;

    $items.each(function () {
      let $item = $(this);
      if (!$item.val()) {
        disabled = true;
        return false;
      }
    });

    $('#optionsModal').find('.btn-confirm').prop('disabled', disabled);
  });

  $('.product .add-btn').on('click', function () {
    // Add item to cart
    let $original = $(this).closest('.product');
    let productId = $original.data('id');
    let productData = window.json_products[productId];
    window.currentProduct = productData;

    if (productData.product_options && productData.product_options.length) {
      let $modal = $('#optionsModal');
      $modal.find('.btn-confirm').prop('disabled', true);
      $modal.find('.modal-title').html('Kies je opties');
      $modal.find('.option-group').remove();

      for (let i in productData.product_options) {
        let optionGroup = productData.product_options[i];

        let $groupTpl = $modal.find('.option-group-tpl');
        let $group = $groupTpl.clone();
        $group.removeClass('option-group-tpl').addClass('option-group').show();

        let $selectLabel = $group.find('.select-items-label');
        $selectLabel.html(optionGroup.title);
        let $select = $group.find('.select-items');
        $select.find('option:not(.label)').remove();
        for (let j in optionGroup.options) {
          let option = optionGroup.options[j];
          let label = option[0];
          let price = option[1];
          if (price > 0) {
            label += " (€ " + number_format(price, 2, ',', ' ') + ")";
          }
          let $option = $('<option data-price="' + price + '" value="' + label + '">' + label + '</option>');
          $option.data('title', option[0]); // original label
          $select.append($option);
        }
        $select.find('option').first().prop('selected', true);

        $modal.find('.modal-body').append($group);
      }

      $modal.modal({
        'backdrop': 'static',
      })
    } else {
      addProductToCart(productData);
    }
  });

  $('.cart-products').on('click', '.rm-btn', function () {
    // Remove item from cart
    let $original = $(this).closest('.product');
    $original.remove();

    // Update totals
    recalcTotals();
    calculateShippingCost();
  });

  $('.cart-products').on('change', 'input.amount', function () {
    // Update totals
    recalcTotals();
    calculateShippingCost();
  });

  $('.add-to-cart-toast').toast();

  $('.delivery-date').on('change', function () {
    let $date = $(this);
    let date = $date.val();
    let $method = $date.closest('.delivery-info');
    let $time = $method.find('select.delivery-time');
    let deliveryMethodKey = $method.data('delivery-key');
    let $infoMessage = $method.find('.delivery-info-message');
    $time.hide();
    $infoMessage.hide();
    $method.find('.no-times').hide();

    $.ajax({
      url: '/delivery-times',
      data: {
        date: date,
        dmethod: deliveryMethodKey,
      },
      method: 'GET',
      dataType: 'json',
      success: function (data) {
        let times = data.times;
        if (times && times.length > 0) {
          $time.find('option.time').remove();
          times.forEach(time => {
            let $e = $('<option class="time" value="' + time + '">' + time + '</option>');
            $time.append($e);
          });

          $time.show();
          if (!data.disableTimeSelection) {
            $time.val($time.find('option').first().val());
          } else {
            $time.val($time.find('option.time').first().val());
          }

          if (data.infoMessage) {
            $infoMessage.html(data.infoMessage);
            $infoMessage.show();
          }
          $method.find('.no-times').hide();

          // Handle delivery regions if they are there
          if (!data.deliveryRegions) {
            data.deliveryRegions = window.json_delivery_regions;
          }
          let $regionSelects = $('form.delivery-address select');
          $regionSelects.each(function () {
            let $regionSelect = $(this);
            $regionSelect.find('option.region').remove();
            Object.keys(data.deliveryRegions).forEach(postalCode => {
              realPostalCode = postalCode.split('_')[0];
              let $e = $('<option class="region" value="' + realPostalCode + '" data-city-text="' + data.deliveryRegions[postalCode] + '">' + realPostalCode + ' ' + data.deliveryRegions[postalCode] + '</option>');
              $regionSelect.append($e);
            });
            $regionSelect.find('option').first().prop('selected', true);
          });
        } else {
          $time.hide();
          $method.find('.no-times').show();
        }
      }
    });
  });

  $('.subscribe-btn').on('click', function (e) {
    e.preventDefault();
    $('.input-errors').hide();
    // AJAX request to subscribe webshop
    $.ajax({
      url: '/subscribe',
      data: {
        name: $('#name').val(),
        email: $('#email').val(),
        phone: $('#phone').val(),
        location: $('#location').val(),
      },
      method: 'POST',
      dataType: 'json',
      success: function (data) {
        if (data.ok) {
          $('#subscribe-ok').show();
          $('.subscribe-btn').hide();
        }
      },
      error: function (xhr) {
        if (xhr.status == 422 && xhr.responseJSON) {
          let data = xhr.responseJSON;
          if (data.errors) {
            $('.input-errors ul li').remove();
            for (field in data.errors) {
              let errors = data.errors[field];
              $('.input-errors ul').append($('<li>' + errors[0] + '</li>'));
            }
            $('.input-errors').show();
          }
        }
      },
    });
  });

  function handlePaymentMethodChange($e) {
    let invoicingEnabled = $e && $e.data('invoicing-enabled') == 1;
    if (invoicingEnabled) {
      $('.invoicing-enabled').show();
      $('.invoicing-disabled').hide();
    } else {
      $('.invoicing-enabled').hide();
      $('.invoicing-disabled').show();
    }
  }

  $('input[name="payment_method"]').on('change, click', function () {
    handlePaymentMethodChange($(this));
  });

  $('.submit-btn').on('click', function (e) {
    e.preventDefault();

    if (typeof Sentry !== 'undefined') {
      Sentry.configureScope(function(scope) {
        scope.setUser({
          'name': $('#order_name').val(),
          'phone': $('#order_phone').val(),
          'email': $('#order_email').val(),
        });
      });
    }

    let $btn = $(this);
    $btn.prop('disabled', true);
    let products = [];
    $('.cart-products .product').each(function () {
      let $cartProduct = $(this);
      let $amount = $cartProduct.find('input.amount');
      let amount = parseInt($amount.val());
      let supplementCost = $cartProduct.data('supplementCost');
      let extraInfo = $cartProduct.data('extraInfo');
      let optionsDetails = $cartProduct.data('optionsDetails');
      products.push({
        id: $cartProduct.data('id'),
        amount: amount,
        supplementCost: supplementCost,
        extraInfo: extraInfo,
        optionsDetails: optionsDetails,
      });
    });
    let $selectedPaymentMethod = $('input[name="payment_method"]:checked');
    let selectedPaymentMethod = $selectedPaymentMethod.val();
    let invoicingEnabled = $selectedPaymentMethod.data('invoicing-enabled');
    let $deliveryInfo = $('.delivery-info[data-delivery-key="' + window.delivery_method.key + '"]');
    let deliveryDate = $deliveryInfo.find('select.delivery-date').val();
    let deliveryTime = $deliveryInfo.find('select.delivery-time').val();
    $('.input-errors').hide();

    initSearchSettings();

    // AJAX request to submit order
    let postData = {
      products: products,
      delivery_method: window.delivery_method.key,
      payment_method: selectedPaymentMethod,
      delivery_address: searchSettings.address ? (searchSettings.address + ' ' + searchSettings.streetnr + (searchSettings.address_suffix ? (' / ' + searchSettings.address_suffix) : '')) : '',
      delivery_postal: searchSettings.postal,
      delivery_city: searchSettings.city,
      delivery_date: deliveryDate,
      delivery_time: deliveryTime,
      order_name: $('#order_name').val(),
      order_email: $('#order_email').val(),
      order_phone: $('#order_phone').val(),
      invoice_requested: $('#invoice_requested').is(':checked') && invoicingEnabled ? 1 : 0,
      invoice_name: $('#invoice_name').val(),
      invoice_address: $('#invoice_address').val(),
      invoice_postal_city: $('#invoice_postal_city').val(),
      invoice_vatnr: $('#invoice_vatnr').val(),
      invoice_comments: $('#invoice_comments').val(),
      comments: $('#order_comments').val(),
    };

    $.ajax({
      url: '/orders',
      data: postData,
      method: 'POST',
      dataType: 'json',
      success: function (data) {
        if (data.ok) {
          if (data.redirect_url) {
            window.location.assign(data.redirect_url);
          } else {
            window.location.assign('/thanks');
          }
        }
        $btn.prop('disabled', false);
      },
      error: function (xhr) {
        if (xhr.status == 422 && xhr.responseJSON && xhr.responseJSON.errors) {
          let data = xhr.responseJSON;
          if (data.errors) {
            $('.input-errors ul li').remove();
            for (field in data.errors) {
              let errors = data.errors[field];
              $('.input-errors ul').append($('<li>' + errors[0] + '</li>'));
            }
            $('.input-errors').show();
          }
        } else {
          if (typeof Sentry !== 'undefined') {
            Sentry.withScope(scope => {
              scope.setExtra('Response Text', xhr.responseText);
              Sentry.captureException(new Error('XHR error ' + xhr.status + ' on submit'));
            });
          }

          $('.input-errors ul li').remove();
          $('.input-errors ul').append($('<li>' + 'Er ging iets mis. Gelieve de webshop te sluiten en opnieuw te openen en nog een keer te proberen' + '</li>'));
          $('.input-errors ul').append($('<li>' + 'Contacteer ons om uw bestelling door te geven indien het ook dan nog steeds niet lukt.' + '</li>'));
          $('.input-errors').show();
        }
        $btn.prop('disabled', false);
      },
    });
  });

  $('#invoice_requested').on('change', function() {
    let requested = $(this).is(':checked');
    if (requested) {
      $('.invoice-fields').show();
    } else {
      $('.invoice-fields').hide();
    }
  });

  // if (window.json_company_settings && window.json_company_settings.use_live_search && false) {
  //   $('.delivery-search').each(function () {
  //     let $search = $(this);
  //     let $searchResult = $search.find('.delivery-search-result');
  //     var placesAutocomplete = places({
  //       appId: 'plEYYD0QTKAK',
  //       apiKey: 'b546fdf568357e9a2d3326acb461dac9',
  //       container: $search.find('.delivery-search-input')[0],
  //       templates: {
  //         value: function (suggestion) {
  //           return suggestion.name;
  //         }
  //       },
  //       language: 'nl',
  //       countries: ['be'],
  //       aroundLatLngViaIP: true,
  //       autocompleteOptions: {
  //         clearOnSelected: true,
  //       }
  //     });
  //     placesAutocomplete.on('change', function resultSelected(e) {
  //       console.log(e.suggestion, e);
  //       let resultHtml = e.suggestion.name + '<br>' + e.suggestion.postcode + ' ' + e.suggestion.city;
  //       $searchResult.html(resultHtml);
  //       searchSettings = {
  //         address: e.suggestion.name,
  //         postal: e.suggestion.postcode,
  //         city: e.suggestion.city,
  //       };
  //     });
  //     placesAutocomplete.on('clear', function resultSelected() {
  //       $searchResult.html($searchResult.data('empty-msg'));
  //       searchSettings = {
  //         address: null,
  //         postal: null,
  //         city: null,
  //       };
  //     });
  //     $searchResult.html($searchResult.data('empty-msg'));
  //   });
  // }

  $('.recalc-distance').on('change', function () {
    calculateShippingCost();
  });
});

let initSearchSettings = function () {
  if (!window.json_company_settings) {
    return;
  }

  if (!window.delivery_method) {
    return;
  }

  if (!window.json_company_settings.use_live_search) {
    searchSettings = {
      address: $('#delivery_address_' + window.delivery_method.key).val(),
      streetnr: '',
      address_suffix: '',
      postal: $('#delivery_postal_' + window.delivery_method.key).val(),
      city: $('#delivery_postal_' + window.delivery_method.key + ' option:selected').data('city-text'),
    };
  } else {
    searchSettings = {
      address: $('#delivery_search_' + window.delivery_method.key).val(),
      streetnr: $('#delivery_streetnr_' + window.delivery_method.key).val(),
      address_suffix: $('#delivery_suffix_' + window.delivery_method.key).val(),
      postal: $('#delivery_postal_' + window.delivery_method.key).val(),
      city: $('#delivery_city_' + window.delivery_method.key).val(),
    };
  }
}

let calculateShippingCost = function () {
  initSearchSettings();
  if (searchSettings.address && searchSettings.postal && searchSettings.city) {
    if (shippingXhr) {
      shippingXhr.abort();
    }
    total = number_format(getTotalForProducts(), 2, '.', '');
    shippingXhr = $.ajax({
      url: '/shipping-cost/' + window.delivery_method.key + '/' + total  + '/' + encodeURIComponent(searchSettings.address + ' ' + searchSettings.streetnr + (searchSettings.suffix ? (' / ' + searchSettings.suffix) : '')) + '/' + encodeURIComponent(searchSettings.postal) + '/' + encodeURIComponent(searchSettings.city),
      method: 'GET',
      dataType: 'text',
      success: function (cost) {
        if (cost < 0) {
          cost = 0;
        }
        shippingCost = cost;
        recalcTotals();
      }
    });
  } else {
    shippingCost = 0;
    recalcTotals();
  }
}

window.initAutocomplete = function () {
  if (!window.json_company_settings) {
    return;
  }

  if (!window.json_company_settings.use_live_search) {
    return;
  }

  $('.delivery-search').each(function () {
    let $search = $(this);
    let $searchResult = $search.find('.delivery-search-result');
    let autocomplete = new google.maps.places.Autocomplete(
      $search.find('.delivery-search-input')[0],
      {types: ["geocode"]}
    );
    $search.find('.delivery-search-input').data('gm-autocomplete', autocomplete);

    let $suffix = $search.find('.delivery_suffix');
    $suffix.on('input', function () {
      searchSettings.address_suffix = $(this).val();
      if (searchSettings.address && searchSettings.postal && searchSettings.city) {
        let resultHtml = searchSettings.address + ' ' + searchSettings.address_suffix + '<br>' + searchSettings.postal + ' ' + searchSettings.city;
        //$searchResult.html(resultHtml);
      }
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy,
        });
        autocomplete.setBounds(circle.getBounds());
      });
    }

    autocomplete.setComponentRestrictions({'country': ['be']});
    autocomplete.setFields(["address_component"]);
    autocomplete.addListener("place_changed", function () {
      const place = autocomplete.getPlace();
      //console.log(place);
      let street = '';
      let streetnr = '';
      let postal = '';
      let city = '';
      for (const component of place.address_components) {
        const addressType = component.types[0];
        if (addressType == 'route') {
          street = component.long_name;
        } else if (addressType == 'locality') {
          city = component.long_name;
        } else if (addressType == 'postal_code') {
          postal = component.short_name;
        } else if (addressType == 'street_number') {
          streetnr = component.short_name;
        }
      }

      if (street && city) {
        searchSettings.address = street;
        searchSettings.postal = postal;
        searchSettings.city = city;
        // let resultHtml = street + ' ' + streetnr + ' ' + searchSettings.address_suffix + '<br>' + postal + ' ' + city;
        //$searchResult.html(resultHtml);
        $search.find('.delivery-search-input').val(street);
        $search.find('.delivery-postal-input').val(postal);
        $search.find('.delivery-city-input').val(city);
        if (streetnr) {
          searchSettings.streetnr = streetnr;
          $search.find('.delivery-streetnr-input').val(streetnr);
        }
        calculateShippingCost();

        // Sometimes autocomplete doesn't return postal when no streetnr is given
        // Example: Peerderbaan, Pelt
        if (!postal && !streetnr) {
          const geocoder = new google.maps.Geocoder();
          const address = street + ' 1, ' + city + ', België';
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === "OK" && results.length > 0) {
              for (const component of results[0].address_components) {
                const addressType = component.types[0];
                //console.log(addressType, component);
                if (addressType == 'postal_code') {
                  postal = component.short_name;
                  searchSettings.postal = postal;
                  $search.find('.delivery-postal-input').val(postal);
                  calculateShippingCost();
                }
              }
            }
          });
        }
      } else {
        searchSettings.address = '';
        searchSettings.postal = '';
        searchSettings.city = '';
        $search.find('.delivery-postal-input').val('');
        $search.find('.delivery-city-input').val('');
        calculateShippingCost();
        //$searchResult.html('<strong style="color: red;">Kies een volledig adres (straat + nr).</strong>');
      }
    });
    $searchResult.html($searchResult.data('empty-msg'));
  });
}

window.gm_authFailure = function () {
  // Re-enable field for normal typing when Google Maps API fails auth
  let $clone = $('.delivery-search-input').clone();
  $('.delivery-search-input').parent().append($clone);
  $('.delivery-search-input').first().remove();
  $('.delivery-search-input').prop('disabled', false);
  $('.delivery-search-input').css('background-image', '');
  $('.delivery-search-input').attr('placeholder', '');
  $('.delivery-search-input').removeClass('gm-err-autocomplete');
};
